<template lang="pug">
	.airbrake-defects-setting
		.defect-config-wrapper(v-for="(defectData, index) in setting.value")
			.defect-title {{(index + 1) + '. ' + defectData.name}}
			.defect-settings
				.defect-setting
					.defect-setting-title.text-muted Enabled
					label.defect-setting-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
						input.switch-input.form-check-input(type="checkbox" :checked="defectData.enabled" @change="setDefectEnabled(defectData.name, $event.target.checked)")
						span.switch-slider(data-checked="On" data-unchecked="Off")
						span.switch-handle
				.defect-setting
					.defect-setting-title.text-muted Check once
					label.defect-setting-control.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
						input.switch-input.form-check-input(type="checkbox" :checked="defectData.checkOnce" @change="setDefectCheckOnce(defectData.name, $event.target.checked)")
						span.switch-slider(data-checked="On" data-unchecked="Off")
						span.switch-handle

</template>

<script>

import Screen 						from './../../mixins/screen'

export default {
	name: "AirbrakeDefectsSettings",
	mixins: [Screen],
	screen: {
		updateOn: [],
		events: {}
	},
	props: ['setting'],
	data() {


		return {
			showed: true
		}
	},


	methods: {

		setDefectEnabled(defectName, value) {

			const defect = this.setting.value.find(defect => defect.name === defectName);
			const defectIndex = this.setting.value.indexOf(defect);

			if (defectIndex < 0) return;

			this.setting.value[defectIndex].enabled = value;

			this.$forceUpdate();
			this.delaySave();

		},

		setDefectCheckOnce(defectName, value) {

			const defect = this.setting.value.find(defect => defect.name === defectName);
			const defectIndex = this.setting.value.indexOf(defect);

			if (defectIndex < 0) return;

			this.setting.value[defectIndex].checkOnce = value;

			this.$forceUpdate();
			this.delaySave();

		},

		delaySave() {

			clearTimeout(this.saveTimeout);
			this.saveTimeout = setTimeout(() => {

				Settings.saveTemplateGlobalSettingValue(this.setting, this.setting.value);

			}, 200);

		}
	}


}
</script>

<style lang="sass">

.airbrake-defects-setting
	display: flex
	flex-direction: column
	padding-top: 10px

	>.defect-config-wrapper
		display: flex
		flex-direction: column
		border-top: 1px solid #24282c
		padding: 5px

		>.defect-title
			padding-bottom: 5px

		>.defect-settings
			display: flex
			flex-direction: column
			font-size: smaller
			gap: 5px

			>.defect-setting
				display: flex
				flex-direction: row
				align-items: center
				gap: 30px

				>.defect-setting-title
					width: 75px

</style>
